import { DomainError } from '@/errors';

export class AddOnError extends DomainError {}
